// extracted by mini-css-extract-plugin
export default {"speechBalloon":"HintOpen_speechBalloon__HbmWb","text":"HintOpen_text__8WYC6"};